/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_SHELF_LIST = gql`
  query GetShelves(
    $options: GetManyOptions
    $filter: ShelfFilterInput
    $getDistCentsFilter: DistCentFilterInput
  ) {
    getShelves(options: $options, filters: $filter) {
      count
      content {
        activeStatus
        createdAt
        distCent{
          id
          name
        }
        _id
        shelfDeliveryStatus
        shelfId
        name
        updatedAt
        band{
          id
          name
        }
        undeliveredBoxesCount
      }
      limit
      skip
    }
    getDistCents(filter: $getDistCentsFilter) {
      content {
        id
        name
        noOfCounters
      }
    }
  }
`;
